export default async function EditProfileApi(
  id,
  firstName,
  lastName,
  country,
  address,
  city,
  gender,
  phone,
  imageUrl
) {
  let res = "";

  try {
    const body = {
      id: id,
      firstName: firstName,
      lastName: lastName,
      country: country,
      address: address,
      city: city,
      gender: gender,
      phone: phone,
      imageUrl: imageUrl,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/users/me/profile`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error update user profile: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
